import { useQuery } from "@tanstack/react-query";

import { coreDataGetCatBreedsOptions } from "@/api_client/@tanstack/react-query.gen";
import { useLanguageFromUrl } from "../useLanguageFromUrl";

export const useCatBreeds = () => {
  const language = useLanguageFromUrl();
  return useQuery({
    ...coreDataGetCatBreedsOptions({ query: { language } }),
    staleTime: (options) => {
      const result =
        Object.keys(options.state.data ?? {}).length > 0 ? Infinity : 0;
      return result;
    },
  });
};

export const useCatBreed = (catBreedKey: string | null | undefined) => {
  const { data: catBreeds, isLoading: isLoadingCatBreeds } = useCatBreeds();
  if (isLoadingCatBreeds || !catBreeds || !catBreedKey) {
    return undefined;
  }
  const catBreedItem = catBreeds?.items?.find((c) => c.key === catBreedKey);
  const catBreed = catBreedItem?.value ?? catBreedKey;
  return catBreed;
};
